<template>
  <section>
    <div class="photos" v-for='(item,index) in model'>
        <div><order-module-title :title="item.partName"/></div>
        <div class="info">
          <img src="" alt="" v-for='(items,index) in JSON.parse(item.pics)' v-lazy="formatImgUrl(items,300,240)" @click='preview(index,JSON.parse(item.pics),item.partName)'/>
        </div>
    </div>
    <previewer ref="previewer"></previewer>
  </section>
</template>

<script>
  export default {
    name: 'photos',
    computed: {
      defaultImg () {
        return this.DEFAULT_IMG
      }
    },
    props : {
      model : {
        type : Array,
        default : () => []
      }
    },
    methods : {
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      preview(index,list,title){
        this.$refs.previewer.show(index, list,title)
      },
    }
  }
</script>

<style scoped lang="scss">
  .photos{
    &>div{
      display: flex;
      justify-content: center;
      &.info{
        padding: 0 30px 30px 50px;
        padding-left: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: normal;
        margin-top: 30px;
        img{
          width: 204px;
          height: 204px;
          margin: 0 20px 20px 0;
          &:nth-child(3n){
            margin-right: 0;
          }
        }
      }
    }
  }
</style>
